import { render, staticRenderFns } from "./ElementSwitch.vue?vue&type=template&id=63bd0f21&scoped=true&"
import script from "./ElementSwitch.vue?vue&type=script&lang=js&"
export * from "./ElementSwitch.vue?vue&type=script&lang=js&"
import style0 from "./ElementSwitch.vue?vue&type=style&index=0&id=63bd0f21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bd0f21",
  null
  
)

component.options.__file = "ElementSwitch.vue"
export default component.exports